export default "__VITE_ASSET__CSzmSxWE__"